import { render, staticRenderFns } from "./flyer2wordpress.vue?vue&type=template&id=dafc37ce&"
import script from "./flyer2wordpress.vue?vue&type=script&lang=js&"
export * from "./flyer2wordpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports